import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import ProductForm from "@components/forms/ProductForm";
import styles from "./style.module.scss";

type ProductAddEditProps = {
  copyData?: boolean
}

const ProductAddEdit = (props: ProductAddEditProps) => {
  const { copyData = false } = props
  const params = useParams()
  const { id: productId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!productId ? 'Agregar' : 'Editar'} Productos`}
      backUrl="/user/products"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "productForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ProductForm
        copyData={copyData}
        formId="productForm"
        id={productId}
        saveRedirectUrl="/user/products"
      ></ProductForm>

    </PageContainer>
  );
}

export default ProductAddEdit;
